module.exports = __webpack_public_path__ + "static/mucoff-logo-5f77f4b68dbbe32a60435dece92b953d.png";